// React Query cache keys for the pick-task prototype feature.
export const PickTasksKey = 'picktasks';
export const PickTaskKey = 'picktask';
export const PickConfigKey = 'pickconfig';
